// directives/dragNext.ts

export const dragfly = {
  mounted(el: HTMLElement) {
    let isDragging = false;
    let startX = 0;
    let startY = 0;
    let initialLeft = 0;
    let initialTop = 0;
    let hasDragged = false;
    const moveThreshold = 6; // 移动阈值（像素）
    const distance = 460; // 自动归边距离（像素）

    function handleMouseDown(e: MouseEvent) {
      isDragging = true;
      hasDragged = false; // 重置状态
      e.preventDefault();

      if (window.getComputedStyle(el).position !== "fixed") {
        el.style.position = "fixed";
      }

      const rect = el.getBoundingClientRect();
      startX = e.clientX;
      startY = e.clientY;
      initialLeft = rect.left;
      initialTop = rect.top;

      el.classList.add("dragging");
      document.body.classList.add("dragging");
      el.style.transition = "none";

      document.addEventListener("mousemove", handleMouseMove);
      document.addEventListener("mouseup", handleMouseUp);
    }

    function handleMouseMove(e: MouseEvent) {
      if (!isDragging) return;

      const deltaX = e.clientX - startX;
      const deltaY = e.clientY - startY;

      // 检测是否达到移动阈值
      if (Math.abs(deltaX) > moveThreshold || Math.abs(deltaY) > moveThreshold) {
        hasDragged = true;
      }

      el.style.left = `${initialLeft + deltaX}px`;
      el.style.top = `${initialTop + deltaY}px`;
    }

    function handleMouseUp(_e: MouseEvent) {
      isDragging = false;

      el.classList.remove("dragging");
      document.body.classList.remove("dragging");
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);

      // 边界吸附逻辑
      const rect = el.getBoundingClientRect();
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;
      let targetTop = rect.top;
      let targetLeft = rect.left;
      let atRight = viewportWidth - rect.right < distance;

      if (targetTop < 0) {
        targetTop = 0;
      }
      if (rect.bottom > viewportHeight) {
        targetTop = viewportHeight - rect.height;
      }
      if (rect.left < distance || viewportWidth - rect.right < distance) {
        targetLeft = rect.left <= viewportWidth - rect.right ? 0 : viewportWidth - rect.width;
      }

      el.style.transition = "left 0.3s ease";
      el.style.top = `${targetTop}px`;
      el.style.left = `${targetLeft}px`;

      setTimeout(() => {
        el.style.transition = "";
        if (atRight) {
          el.style.left = "unset";
          el.style.right = "0px";
        }
      }, 300);

      // 阻止点击事件的核心逻辑
      if (hasDragged) {
        const clickInterceptor = (e: MouseEvent) => {
          e.stopPropagation();
          e.preventDefault();
          document.removeEventListener("click", clickInterceptor, true);
        };
        document.addEventListener("click", clickInterceptor, true);
      }
    }

    el.addEventListener("mousedown", handleMouseDown);
  },
};

export default dragfly;
